import { format, isToday } from "date-fns";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("ja");

export const formatDate = (date: Date | string) => {
  const _date = new Date(date);
  return new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(_date);
};

export const formatDateWithoutTime = (date: Date | string) => {
  const _date = new Date(date);
  return new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(_date);
};

// Trong khoảng 1 ngày trở lại thì hiển thị "x hours ago", "x minutes ago", nếu quá 1 ngày thì hiển thị định dạng ngày tháng năm giờ
export const formatDateFromNow = (date: Date | string) => {
  const diffInDays = dayjs().diff(dayjs(date), "day");
  if (diffInDays === 0) {
    return dayjs(date).fromNow(); // ví dụ "3 minutes ago"
  }
  return formatDate(date);
};

// Format date in chat messages
export const formatDateChat = (date: Date | string): string => {
  const _date = new Date(date);

  if (isToday(_date)) {
    // Nếu trong ngày hôm nay -> 4:04 PM
    return format(_date, "h:mm a");
  } else {
    // Nếu xa hơn -> 20/10/2025 4:04 PM
    return format(_date, "yyy/MM/dd h:mm a");
  }
};

// Format date
export const formatDateCustom = (
  date: Date | string,
  formatStr?: string
): string => {
  const _date = new Date(date);
  return dayjs(_date).format(formatStr || "YYYY-MM-DD");
};
